<template>
    <v-dialog
            scrollable
            v-model="visible"
            max-width="900px"
            :fullscreen="fullscreen"
            :persistent="true">
        <v-card>
            <v-toolbar flat dense>
                <v-toolbar-title class="subheading">查看</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="fullscreen=!fullscreen">
                    <v-icon>fullscreen</v-icon>
                </v-btn>
            </v-toolbar>

            <v-divider style="max-height: 1px"/>
            <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap>

                        <v-flex xs8>
                            <div class="x-text-field">
                                <label>预算模板</label>
                                <div>{{item.tplName}}</div>
                            </div>
                        </v-flex>

                        <v-flex xs4>
                            <div class="x-text-field">
                                <label>经费(元)</label>
                                <div>{{item.amount | currency}}</div>
                            </div>
                        </v-flex>

                        <v-flex xs12>
                            <v-data-table
                                    class="dense"
                                    :headers="headers"
                                    :items="item.budgetItems"
                                    hide-actions>
                                <template slot="items" slot-scope="props">
                                    <td>{{ props.index + 1}}</td>
                                    <td>
                                            <span :style="`padding-left: ${props.item.level-1}em`">
                                            {{props.item.tplName}}
                                            </span>
                                    </td>
                                    <td>
                                        {{props.item.amount | currency}}
                                    </td>
                                </template>
                            </v-data-table>
                        </v-flex>

                        <v-flex xs12>
                            <div class="x-text-field">
                                <label>备注</label>
                                <div>{{item.note}}</div>
                            </div>
                        </v-flex>

                    </v-layout>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer/>
                <v-btn color="primary" @click.native="visible=false">关闭</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    import mixin from '@/mixin'

    const baseURI = '/api/proj/budget-item';

    export default {
        mixins: [mixin.view(baseURI)],
        props: ['value', 'dbid', 'projectId'],

        data() {
            return {
                item: {
                    budgetItems: []
                },

                headers: [
                    {text: '#', sortable: false, value: 'rank', width: 18},
                    {text: '科目', sortable: false, value: 'tpl_name'},
                    {text: '经费（元）', sortable: false, value: 'amount', width: 180},
                    // {text: '备注', sortable: false, value: 'note', width: 230},
                ],
            }
        },
        methods: {
            get() {
                const vm = this;
                this.loading = true;
                this.axios.get(`${baseURI}/${this.dbid}`)
                    .then(rsp => {
                        // 填充对话框
                        vm.loading = false;
                        if (rsp.data.length > 0) {
                            vm.item = rsp.data.shift();
                            vm.item.budgetItems = rsp.data;
                        }
                    });
            }
        }
    }
</script>
